export default __webpack_public_path__ + "static/reasonBg-290bf0fa1c38a46898e862fc4c2cf228.svg";